/**
 * ENG-3413 — the sign-in method `UserInfo.provider` records, from Firebase's `providerData`.
 *
 * Settings shows its Password card only for `"password"`, so this must say `"password"` exactly when
 * the account has one. It read `providerData[0]`, which went wrong two ways:
 *
 * - An account with a password that is not its FIRST linked method (Google first, say) read as that
 *   other method, so it could not change the password it has.
 * - An empty `providerData`, an account with no linked sign-in method, fell back to `"password"` and
 *   was offered a Password card it has no password for. Its "Forgot your current password?" then
 *   emails a reset link that adds one.
 */
export const accountProvider = (providerData: ReadonlyArray<{ providerId: string }>): string => {
  if (providerData.some((p) => p.providerId === "password")) return "password";
  return providerData[0]?.providerId ?? "none";
};
